(function(algolia, searchClientV5) {
  'use strict';

  if (
    !algolia ||
    !algolia.config ||
    !algolia.externals ||
    algolia.config.search_client_version !== 5
  ) {
    return;
  }

  if (!searchClientV5 || typeof searchClientV5.liteClient !== 'function') {
    throw new Error('Algolia search client v5 failed to load');
  }

  var knownOrganicTags = [
    'organic-saffron',
    'organic-cinnamon',
    'organic saffron',
    'organic',
  ];

  function getOrganicTagList() {
    return knownOrganicTags.slice();
  }

  function getOrganicFacetFilters() {
    return knownOrganicTags.map(function(tag) {
      return 'tags:' + tag;
    });
  }

  function updateKnownOrganicTagsFromFacets(result) {
    if (!result || typeof result !== 'object') return;
    var facetsToCheck = [
      result.facets,
      result.disjunctiveFacets,
      result.hierarchicalFacets,
    ];
    facetsToCheck.forEach(function(facets) {
      if (!facets || typeof facets !== 'object' || !facets.tags) return;
      var tagsObj = facets.tags;
      var totalOrganicCount = 0;
      Object.keys(tagsObj).forEach(function(tag) {
        if (/^organic([-_\s]|$)/i.test(tag) || tag.toLowerCase() === 'organic') {
          if (knownOrganicTags.indexOf(tag) === -1) {
            knownOrganicTags.push(tag);
          }
          if (tag !== 'organic') {
            totalOrganicCount += Number(tagsObj[tag]) || 0;
          }
        }
      });
      if (
        totalOrganicCount > 0 &&
        (tagsObj.organic === undefined || tagsObj.organic === 0)
      ) {
        tagsObj.organic = totalOrganicCount;
      }
    });
  }

  function transformFacetFilters(facetFilters) {
    if (!facetFilters) return facetFilters;

    if (typeof facetFilters === 'string') {
      try {
        var parsed = JSON.parse(facetFilters);
        return JSON.stringify(transformFacetFilters(parsed));
      } catch (e) {
        if (
          facetFilters.indexOf('tags:organic') !== -1 ||
          facetFilters.indexOf('tags:"organic"') !== -1
        ) {
          var replacement = '(' + getOrganicFacetFilters().join(' OR ') + ')';
          return facetFilters.replace(/tags:\s*"?organic"?/g, replacement);
        }
        return facetFilters;
      }
    }

    if (Array.isArray(facetFilters)) {
      return facetFilters.map(function(item) {
        if (typeof item === 'string') {
          if (item === 'tags:organic' || item === 'tags:"organic"') {
            return getOrganicFacetFilters();
          }
          return item;
        }
        if (Array.isArray(item)) {
          var hasExactOrganic = item.some(function(v) {
            return v === 'tags:organic' || v === 'tags:"organic"';
          });
          if (hasExactOrganic) {
            var newGroup = [];
            item.forEach(function(v) {
              if (v === 'tags:organic' || v === 'tags:"organic"') {
                getOrganicFacetFilters().forEach(function(ot) {
                  if (newGroup.indexOf(ot) === -1) newGroup.push(ot);
                });
              } else {
                if (newGroup.indexOf(v) === -1) newGroup.push(v);
              }
            });
            return newGroup;
          }
          return item;
        }
        return item;
      });
    }

    return facetFilters;
  }

  function transformFiltersString(filters) {
    if (typeof filters !== 'string' || !filters) return filters;
    if (
      filters.indexOf('tags:organic') !== -1 ||
      filters.indexOf('tags:"organic"') !== -1
    ) {
      var organicClause =
        '(' +
        getOrganicFacetFilters()
          .map(function(t) {
            return t.indexOf(' ') !== -1
              ? 'tags:"' + t.replace('tags:', '') + '"'
              : t;
          })
          .join(' OR ') +
        ')';
      return filters
        .replace(/tags:\s*"organic"/g, organicClause)
        .replace(/tags:\s*organic\b/g, organicClause);
    }
    return filters;
  }

  function transformTagFilters(tagFilters) {
    if (!tagFilters) return tagFilters;
    if (typeof tagFilters === 'string') {
      try {
        var parsed = JSON.parse(tagFilters);
        return JSON.stringify(transformTagFilters(parsed));
      } catch (e) {
        if (tagFilters === 'organic') return JSON.stringify(getOrganicTagList());
        return tagFilters;
      }
    }
    if (Array.isArray(tagFilters)) {
      return tagFilters.map(function(item) {
        if (item === 'organic') return getOrganicTagList();
        if (Array.isArray(item)) {
          if (item.indexOf('organic') !== -1) {
            var newGroup = [];
            item.forEach(function(t) {
              if (t === 'organic') {
                getOrganicTagList().forEach(function(ot) {
                  if (newGroup.indexOf(ot) === -1) newGroup.push(ot);
                });
              } else {
                if (newGroup.indexOf(t) === -1) newGroup.push(t);
              }
            });
            return newGroup;
          }
        }
        return item;
      });
    }
    return tagFilters;
  }

  function transformQueryParamsString(queryString) {
    if (!queryString || typeof queryString !== 'string') return queryString;
    var pairs = queryString.split('&');
    var transformedPairs = pairs.map(function(pair) {
      var eqIdx = pair.indexOf('=');
      if (eqIdx === -1) return pair;
      var key = decodeURIComponent(pair.slice(0, eqIdx));
      var val = decodeURIComponent(pair.slice(eqIdx + 1));
      if (key === 'facetFilters') {
        var transformed = transformFacetFilters(val);
        return (
          encodeURIComponent(key) +
          '=' +
          encodeURIComponent(
            typeof transformed === 'string'
              ? transformed
              : JSON.stringify(transformed)
          )
        );
      }
      if (key === 'filters') {
        return (
          encodeURIComponent(key) +
          '=' +
          encodeURIComponent(transformFiltersString(val))
        );
      }
      if (key === 'tagFilters') {
        var transformedTag = transformTagFilters(val);
        return (
          encodeURIComponent(key) +
          '=' +
          encodeURIComponent(
            typeof transformedTag === 'string'
              ? transformedTag
              : JSON.stringify(transformedTag)
          )
        );
      }
      return pair;
    });
    return transformedPairs.join('&');
  }

  function transformSearchRequest(request) {
    if (!request) return request;
    var transformed = Object.assign({}, request);

    if (typeof transformed.params === 'string') {
      transformed.params = transformQueryParamsString(transformed.params);
    } else if (transformed.params && typeof transformed.params === 'object') {
      var p = Object.assign({}, transformed.params);
      if (p.facetFilters) p.facetFilters = transformFacetFilters(p.facetFilters);
      if (p.filters) p.filters = transformFiltersString(p.filters);
      if (p.tagFilters) p.tagFilters = transformTagFilters(p.tagFilters);
      transformed.params = p;
    }

    if (transformed.facetFilters) {
      transformed.facetFilters = transformFacetFilters(transformed.facetFilters);
    }
    if (transformed.filters) {
      transformed.filters = transformFiltersString(transformed.filters);
    }
    if (transformed.tagFilters) {
      transformed.tagFilters = transformTagFilters(transformed.tagFilters);
    }

    return transformed;
  }

  function createSearchClient(appId, apiKey, options) {
    var client = searchClientV5.liteClient(appId, apiKey, options);
    var origSearch = client.search.bind(client);

    client.search = function(requests, requestOptions) {
      var transformedRequests = Array.isArray(requests)
        ? requests.map(transformSearchRequest)
        : requests;
      return origSearch(transformedRequests, requestOptions).then(function(
        response
      ) {
        if (response && Array.isArray(response.results)) {
          response.results.forEach(updateKnownOrganicTagsFromFacets);
        }
        return response;
      });
    };

    if (typeof client.searchForHits === 'function') {
      client.searchForHits = function(requests, requestOptions) {
        return client.search(requests, requestOptions);
      };
    }

    if (typeof client.searchForFacets === 'function') {
      client.searchForFacets = function(requests, requestOptions) {
        return client.search(requests, requestOptions);
      };
    }

    return client;
  }

  var externals = {};
  Object.keys(algolia.externals).forEach(function(name) {
    externals[name] = algolia.externals[name];
  });
  externals.algoliasearch = createSearchClient;
  algolia.externals = externals;
})(window.algoliaShopify, window['algoliasearch/lite']);
